// @flow
import React from 'react'
import TextWithNewlines from '../../TextWithNewlines'
import styled, { type StyledComponent } from 'styled-components'
import { clearFix } from '../controls'
import menuImage from '../images/vk-promo-menu.png'
import logo from '../images/vk-promo-logo.png'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import ImagePreview from '../../ImagePreview'

import type { Media, Public, Crop } from '../../types'
import { translateFunc, translations } from '../../../shared/localize'
import _ from 'lodash'

import vkLikeIcon from '../images/vk-like.svg'
import vkShareIcon from '../images/vk-share.svg'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, Roboto, Open Sans, Helvetica Neue, sans-serif;
  background-color: white;
  padding: 20px;
  padding-bottom: 0;
`
const Heading: StyledComponent<Object, any, any> = styled.div`
  ${clearFix()} padding-bottom: 5px;
`
const HeadingSidebar: StyledComponent<Object, any, any> = styled.div`
  float: right;
`
const Menu: StyledComponent<Object, any, any> = styled.div`
  width: 22px;
  height: 34px;
  background: url(${menuImage}) center center no-repeat;
  background-size: 18px 4px;
`
const HeadingInfo: StyledComponent<Object, any, any> = styled.div`
  padding-top: 8px;
  margin-left: 65px;
`
const HeadingTitle: StyledComponent<Object, any, any> = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #2a5885;
`
const Promotion: StyledComponent<Object, any, any> = styled.div`
  font-weight: 400;
  font-size: 12.5px;
  line-height: 14px;
  color: #939393;
`
const Container: StyledComponent<Object, any, any> = styled.div`
  ${clearFix()};
`
const PostText: StyledComponent<Object, any, any> = styled.div`
  font-size: 13px;
  line-height: 1.462;
  padding-top: 3px;
  overflow: hidden;
  word-wrap: break-word;
  width: 513px;
`
const Link: StyledComponent<Object, any, any> = styled.div`
  border: 1px solid rgba(0, 20, 51, 0.12);
  border-radius: 2px;
  margin-top: 12px;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  margin-bottom: 7px;
  font-size: 16px;
  line-height: 21px;
  font-weight: 400;
  width: 430px;
`
const Domain: StyledComponent<Object, any, any> = styled.div`
  font-size: 12.5px;
  color: #939393;
  line-height: 12px;
`
const LinkSidebar: StyledComponent<Object, any, any> = styled.div`
  padding: 10px 15px 11px;
`
const LinkTextData: StyledComponent<Object, any, any> = styled.div`
  line-height: 17px;
  font-size: 12.5px;
  display: table;
  width: 100%;
  box-sizing: border-box;
  position: relative;
`
const ActionButton: StyledComponent<Object, any, any> = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 7px 16px 8px;
  margin: 0;
  font-size: 12.5px;
  display: inline-block;
  zoom: 1;
  cursor: pointer;
  white-space: nowrap;
  outline: none;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif;
  vertical-align: top;
  line-height: 15px;
  text-align: center;
  text-decoration: none;
  background: none;
  background-color: #5181b8;
  color: #fff;
  border: 0;
  border-radius: 4px;
  box-sizing: border-box;
`
const FeedbackSidebar: StyledComponent<Object, any, any> = styled.div`
  padding-top: 12px;
  padding-bottom: 14px;
  ${clearFix()};
`
const FeedbackButton: StyledComponent<Object, any, any> = styled.div`
  color: #2a5885;
  padding-right: 21px;
  float: left;
  ${clearFix()};
`
const FeedbackButtonText: StyledComponent<Object, any, any> = styled.div`
  font-size: 13px;
  line-height: 15px;
  height: 14px;
  font-weight: 500;
  padding-top: 2px;
  margin-left: 8px;
  float: left;
  color: #848a97;
`
const FeedbackButtonIconLike: StyledComponent<Object, any, any> = styled.div`
  background-position: 0 0;
  background: url(${vkLikeIcon}) no-repeat;
  width: 24px;
  height: 24px;
`
const FeedbackButtonIconShare: StyledComponent<Object, any, any> = styled.div`
  width: 24px;
  height: 24px;
  background: url(${vkShareIcon}) no-repeat;
`

type Props = {|
  title: string,
  linkTitle: string,
  description: string,
  url: string,
  image: ?Media,
  imageCrop: ?Crop,
  logoImage: ?Media,
  logoImageCrop: ?Crop,
  publicInfo: Public,
  hasButton: boolean,
  linkButton: string
|}

const t = translateFunc(translations.provider_previews.vk)

export default function VkPromoPost(props: Props) {
  const {
    url,
    title,
    linkTitle,
    description,
    image,
    imageCrop,
    logoImage,
    logoImageCrop,
    publicInfo,
    linkButton
  } = props

  return (
    <Wrapper>
      <Heading>
        <HeadingSidebar>
          <Menu />
        </HeadingSidebar>
        <div>
          <ImagePreview
            width={50}
            height={50}
            imageSrc={(publicInfo && publicInfo.image_url) || (logoImage && logoImage.src) || logo}
            size={{
              width: (logoImage && logoImage.width) || 50,
              height: (logoImage && logoImage.height) || 50
            }}
            crop={logoImageCrop}
            float
            isRounded
          />
        </div>
        <HeadingInfo>
          <HeadingTitle>
            {linkTitle || (_.isEmpty(publicInfo) ? 'Название группы' : publicInfo.label)}
          </HeadingTitle>
          <Promotion>Рекламная запись</Promotion>
        </HeadingInfo>
      </Heading>
      <Container>
        <PostText>
          <TextWithNewlines value={description} />
        </PostText>
        <Link>
          <OptionalResponsibleImage image={image} imageCrop={imageCrop} width={513} ratio={2.24} />
          <LinkSidebar>
            <LinkTextData>
              <Title>{title}</Title>
              <Domain>{url}</Domain>
              {props.hasButton && <ActionButton>{t(linkButton)}</ActionButton>}
            </LinkTextData>
          </LinkSidebar>
        </Link>
      </Container>
      <FeedbackSidebar>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FeedbackButton style={{ display: 'flex', alignItems: 'center' }}>
            <FeedbackButtonIconLike />
            <FeedbackButtonText>157 Нравится</FeedbackButtonText>
          </FeedbackButton>
          <FeedbackButton style={{ display: 'flex', alignItems: 'center' }}>
            <FeedbackButtonIconShare />
            <FeedbackButtonText>26</FeedbackButtonText>
          </FeedbackButton>
        </div>
      </FeedbackSidebar>
    </Wrapper>
  )
}
